export default __webpack_public_path__ + "static/media/AURORA.e07e6b26.svg";